// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsInvoices_HasAuthorizedResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /subaccounts/invoices/has_authorized/{id}
 *
 * Returns {authorized: bool} — whether the invoice is in an
 * authorized/submitted fiscal state.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsInvoices_HasAuthorizedResponseDados {
authorized: boolean
}

export type SubaccountsInvoices_HasAuthorizedResponse = ApiResponse<SubaccountsInvoices_HasAuthorizedResponseDados>;

registerResponseContract('SubaccountsInvoices_HasAuthorizedResponse', {
  authorized: { type: 'boolean', required: true },
})
